import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-visible",
  "use": "icon-visible-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-visible\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M5.5,12A6.49,6.49,0,0,1,12,7a6.5,6.5,0,0,1,6.5,5A6.49,6.49,0,0,1,12,17,6.5,6.5,0,0,1,5.5,12ZM12,15.06A3.15,3.15,0,0,0,15.24,12,3.15,3.15,0,0,0,12,8.94,3.15,3.15,0,0,0,8.76,12,3.15,3.15,0,0,0,12,15.06Zm0-1.23A1.83,1.83,0,1,1,13.94,12,1.89,1.89,0,0,1,12,13.83Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol